import { useState, useEffect } from 'react';
import { ReadingsService } from 'src/services/readings/readings.service';
import { subHours } from 'date-fns';
import { LatestReadingsResponse, LatestReadingWithDisplay } from 'src/types/readings/readings';

type UseGatewayReadingsArgs = {
  gatewayId?: string;
  tagId?: string;
};

export const useGatewayReadings = ({ gatewayId, tagId }: UseGatewayReadingsArgs) => {
  const [readings, setReadings] = useState<LatestReadingsResponse>({});
  const [isDataReady, setIsDataReady] = useState<boolean>(false);

  const now = new Date();
  const threeHoursAgo = subHours(now, 3);
  const formattedStartDateThreeHoursAgo = threeHoursAgo.toISOString();
  const formattedEndDate = now.toISOString();

  const stardDate = formattedStartDateThreeHoursAgo;

  const display = readings && (readings[tagId!] as LatestReadingWithDisplay)?.display;

  useEffect(() => {
    if (!gatewayId || !tagId) return;
    ReadingsService.getReadingsNewDataStorage({
      gatewayId: gatewayId,
      startDate: stardDate,
      endDate: formattedEndDate,
      measurements: tagId,
      aggregationType: null,
      includeDisplayConfig: true,
    })
      .then((res) => {
        setReadings(res.data);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsDataReady(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagId, gatewayId]);

  return { readings, isDataReady, display };
};
